import { render } from "./GuestShiftDetail.vue?vue&type=template&id=4e27c710"
import script from "./GuestShiftDetail.vue?vue&type=script&lang=js"
export * from "./GuestShiftDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__